import { render, staticRenderFns } from "./Confetti.vue?vue&type=template&id=770e526c&scoped=true"
import script from "./Confetti.vue?vue&type=script&lang=js"
export * from "./Confetti.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=770e526c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770e526c",
  null
  
)

export default component.exports